var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"modal"},[_c('v-card',[_c('v-btn',{staticClass:"btn-close px-6 mx-4",attrs:{"small":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-close")])],1),[_vm._t("default")]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }